import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'
import { SponsoredReportGame } from '../../../../contexts/ReportsContextHelper'
import classNames from 'classnames'
import { getIcon } from '../../../../common/components/icons/utils'

type SponsoredReportingGameCardProps = {
  game: SponsoredReportGame
  onOpenGame?: (game: SponsoredReportGame) => void
  hideDetails?: boolean
}

export const SponsoredReportingGameCard: React.FC<SponsoredReportingGameCardProps> = ({
  game,
  onOpenGame,
  hideDetails = false,
}) => {
  const { t } = useTranslation()
  const { thumbnailUrl, gameName, createdAt, updatedAt, numberOfDownloadedGames, numberOfPlayers, ratingDetails } = game

  const handleOpenGame = useCallback(() => {
    if (onOpenGame) onOpenGame(game)
  }, [game, onOpenGame])

  return (
    <div className={styles.reportingGameCardContainer} key={game.conlibGameId} onClick={handleOpenGame}>
      <div className={classNames(styles.top, styles.reportingGameTop, hideDetails && styles.reportingGameLargerTop)}>
        <img crossOrigin='anonymous' src={'https://seppo-proxy.herokuapp.com/' + thumbnailUrl} alt='' />
        {ratingDetails && ratingDetails.av_rating && (
          <div className={classNames(styles.ratingPill, hideDetails && styles.ratingPillLarger)}>
            <span>{getIcon('star')}</span>
            <div className={styles.ratingNumber}>{ratingDetails.av_rating.toFixed(1)}</div>
            {hideDetails && (
              <div>
                {'(' + (game.ratingDetails.details.length ?? 0)}{' '}
                {t('rating.rating_modal.ratings.ratings_amount', 'ratings') + ')'}
              </div>
            )}
          </div>
        )}
      </div>
      {!hideDetails && (
        <div className={styles.sponsoredBottom}>
          <h5 className={styles.sponsoredGameTitle}>
            {gameName || t('game_info.missing_title_placeholder', 'Game title missing')}
          </h5>
          <div className={styles.sponsoredInfoArea}>
            <div className={styles.topPlayedInfoRow}>
              <div className={styles.gameInfo}>
                <span className={styles.topPlayedInfoIcon}>{getIcon('calendar')}</span>
                <span>{new Date(createdAt + '').toLocaleDateString()}</span>
              </div>
              <div className={styles.gameInfo}>
                <span className={styles.topPlayedInfoIcon}>{getIcon('download')}</span>
                <span>
                  {t('game_info.downloads_count', {
                    amount: numberOfDownloadedGames,
                    defaultValue: '%{amount} downloads',
                  })}
                </span>
              </div>
            </div>
            <div className={styles.topPlayedInfoRow}>
              <div className={styles.gameInfo}>
                <span className={styles.topPlayedInfoIcon}>{getIcon('changeIcon')}</span>
                <span>{new Date(updatedAt + '').toLocaleDateString()}</span>
              </div>
              <div className={styles.gameInfo}>
                <span className={styles.topPlayedInfoIcon}>{getIcon('multipleUsers')}</span>
                <span>
                  {t('game_info.players_count', { count: numberOfPlayers, defaultValue: '%{count} players' })}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
